import { waitForPageLoadAnalytics } from "./pageLoad";
import { getCommons, getGlobalEvars } from "./common";
import getWindow from "../utils/window";
import { clearEvents, setEvents, setLinkTrackEvents } from "./events";
import { getCustomerIsAuthenticated } from "../utils/identity";

export const ANONYMOUS_BACK_IN_STOCK_MODAL_TRACKING_NAME =
  "anonymousBackInStockModal";

const LINK_TRACK_VARS = ["prop31", "eVar106"];

const getLoggedInStatus = async () => {
  const isAuthenticated = await getCustomerIsAuthenticated();
  return isAuthenticated ? "logged in" : "anonymous";
};

async function fireLinkTrackEvent({
  eVar106,
  label,
  selectedVariantId,
  events,
}) {
  await waitForPageLoadAnalytics;

  const s = getWindow().s;

  clearEvents({ trackingName: ANONYMOUS_BACK_IN_STOCK_MODAL_TRACKING_NAME });
  setEvents({
    events,
    trackingName: ANONYMOUS_BACK_IN_STOCK_MODAL_TRACKING_NAME,
  });
  s.products = `;${selectedVariantId}`;

  const overrides = {
    prop31: await getLoggedInStatus(),
    eVar106,
    linkTrackEvents: setLinkTrackEvents({
      trackingName: ANONYMOUS_BACK_IN_STOCK_MODAL_TRACKING_NAME,
    }),
    linkTrackVars: getCommons().setLinkTrackVars([
      ...getGlobalEvars(),
      ...LINK_TRACK_VARS,
    ]),
  };

  s.tl(true, "o", label, overrides);
}

export async function fireDifferentEmailClickAnalytics(selectedVariantId) {
  await fireLinkTrackEvent({
    eVar106: "anonymous notify me|different email button|click",
    label: "anonymous back in stock - use different email",
    selectedVariantId,
    events: ["event172"],
  });
}

export async function fireAnonymousBackInStockSuccessAnalytics(
  selectedVariantId
) {
  await fireLinkTrackEvent({
    eVar106: "anonymous notify me screen|notify me button|click",
    label: "anonymous back in stock - notification success",
    selectedVariantId,
    events: ["event172", "event365"],
  });
}

export async function fireRegisteredAccountScreenLoadAnalytics(
  selectedVariantId
) {
  await fireLinkTrackEvent({
    eVar106: "anonymous notify me|existing account screen|load",
    label: "anonymous back in stock - existing account screen load",
    selectedVariantId,
    events: ["event172"],
  });
}
